// Schema for DJs / Bands / Musicians vendor-type-specific fields.

import { DJ_BAND_SERVICES, DJ_GENRES, BAND_GENRES, BAND_MUSICIAN_SERVICES, DJ_BAND_EQUIPMENT, DJ_BAND_CUSTOMIZATIONS } from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const djBandMusicianSchema = {
  vendorType: 'DJs',
  fields: [
    { key: 'djBandMusicianSpec', type: 'chips', label: 'Specializes In *', displayLabel: 'Specializes In', options: ['DJ', 'Band', 'Musician'] },
    {
      type: 'row',
      fields: [
        { key: 'djBandStartingPrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'djBandAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    { key: 'djBandServices', type: 'chips', label: 'Services', options: DJ_BAND_SERVICES, optional: true },
    {
      key: 'djGenresGroup',
      type: 'group',
      style: 'none',
      showIf: { field: 'djBandMusicianSpec', includes: 'DJ' },
      fields: [
        { key: 'djGenres', type: 'chips', label: 'DJ Genres', options: DJ_GENRES, optional: true },
      ],
    },
    {
      key: 'bandMusicianGroup',
      type: 'group',
      style: 'none',
      showIf: { field: 'djBandMusicianSpec', includesAny: ['Band', 'Musician'] },
      fields: [
        { key: 'bandGenres', type: 'chips', label: 'Band/Musician Genres', options: BAND_GENRES, optional: true },
        { key: 'bandMusicianServices', type: 'chips', label: 'Band/Musician Services', options: BAND_MUSICIAN_SERVICES, optional: true },
        { key: 'bandSamplePerformance', type: 'checkbox', label: 'Sample performance available' },
        { key: 'bandNumMusicians', type: 'number', label: 'Number of Musicians', optional: true },
        { key: 'bandInstruments', type: 'text', label: 'Instruments Played', maxLength: 150, optional: true },
      ],
    },
    { key: 'djBandEquipment', type: 'chips', label: 'Equipment', options: DJ_BAND_EQUIPMENT, optional: true },
    { key: 'djBandCustomizations', type: 'chips', label: 'Customizations', options: DJ_BAND_CUSTOMIZATIONS, optional: true },
    { key: 'djBandOffersOtherItems', type: 'checkbox', label: 'Rental Items' },
    ...rentalItemsGroupFields('djBandOffersOtherItems'),
  ],
  requiredChips: [
    { key: 'djBandMusicianSpec', label: 'specialization' },
  ],
  priceValidations: [
    { startingKey: 'djBandStartingPrice', avgKey: 'djBandAvgPrice' },
  ],
};